"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorFilter = void 0;
var ErrorFilter = /** @class */ (function () {
    function ErrorFilter(filters) {
        this.filters = filters;
    }
    ErrorFilter.prototype.approve = function (error) {
        var message;
        var stack;
        var name;
        if (typeof error === 'string') {
            message = error;
        }
        else {
            message = error.message;
            stack = error.stack;
            name = error.name;
        }
        return !this.filters.some(function (filter) {
            return (message && filter.test(message)) || (stack && filter.test(stack)) || (name && filter.test(name));
        });
    };
    return ErrorFilter;
}());
exports.ErrorFilter = ErrorFilter;
//# sourceMappingURL=ErrorFilter.js.map